
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`How can I override styles with higher specificity?`}</h2>
    <p>{`The way to override styles with a high specificity is to simply increase the specificity of your own styles. This could be done using `}<inlineCode parentName="p">{`!important`}</inlineCode>{`, but that's error prone and generally not a good idea.`}</p>
    <p>{`We recommend the following technique:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`const MyStyledComponent = styled(AlreadyStyledComponent)\`
  &&& {
    color: palevioletred;
    font-weight: bold;
  }
\`
`}</code></pre>
    <p>{`Each `}<inlineCode parentName="p">{`&`}</inlineCode>{` gets replaced with the generated class, so the injected CSS then looks like this:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-css"
      }}>{`.MyStyledComponent-asdf123.MyStyledComponent-asdf123.MyStyledComponent-asdf123 {
  color: palevioletred;
  font-weight: bold;
}
`}</code></pre>
    <p>{`The repeated class bumps the specificity high enough to override the source order without being very tedious to write!`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;